<template>
  <div class="input-container">
    <label
      for="first_name"
      class="input__label"
    >First Name</label>
    <input
      id="first_name"
      v-model.lazy="$v.fName.$model"
      class="input"
      :class="{'input--error' : ($v.fName.$invalid === true && $v.fName.$error === true)}"
      type="text"
      name="first_name"
      @focusout="updateName"
    >
    <span
      v-show="($v.fName.$invalid === true && $v.fName.$error === true)"
      class="input__error"
    >
      Invalid first name
    </span>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  props: {
    firstName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      fName: ''
    }
  },
  watch: {
    '$v.fName.$invalid': function (val) {
      if (val === false) {
        this.$emit('input', this.fName)
      }
      this.$emit('valid', (val === false), this.$options._componentTag)
    }
  },
  validations: {
    fName: {
      required,
      minLength: minLength(3),
      hasVowel (fName) {
        if (fName.match(/[0-9]/g)) {
          return false
        }
        return !!fName.toLowerCase().match(/[aeiou]/gi)
      }
    }
  },
  mounted () {
    if (this.firstName) { this.fName = this.firstName }
  },
  methods: {
    updateName () {
      if (this.fName.$invalid !== true && this.fName.$error !== true) {
        this.$emit('input', this.fName)
      }
    },
    triggerTouch () {
      this.$v.$touch()
    },
    onInput (e) {
      this.lName = e.target.value.replace(/\s/g, '')
      e.target.value = this.lName
      setTimeout(() => e.target.setSelectionRange(e.target.value.length, e.target.value.length), 0)
    }
  }
}
</script>
